export default __webpack_public_path__ + "static/media/discount_accepted.cfafc17b.svg";